import { useQuery } from '../../index';
import { query } from './auth0-roles-query-builder';
import permissions from '../../Apollo/permissions';
import sortRoles from './sort-roles';

export default function useQueryRoles({ onCompleted, ...options } = {}) {
  const { data, loading, error, isAllowed } = useQuery(query, {
    context: { permission: permissions.readUsersRoles },
    onCompleted: response => {
      if (onCompleted) {
        onCompleted(transformData(response.data));
      }
    },
    ...options,
  });

  return {
    roles: transformData(data),
    loading,
    isAllowed,
    error,
  };
}

function transformData(data) {
  if (!data) {
    return [];
  }
  return sortRoles(data.auth0_roles);
}
